import { FC } from 'react';

import { LoadingIndicator } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

const FullscreenLoading: FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    {...props}
    className={cn(
      'flex h-screen items-center justify-center bg-transparent',
      className,
    )}
  >
    <LoadingIndicator size="lg" variant="page" />
  </div>
);

export default FullscreenLoading;
